module.exports = __webpack_public_path__ + "static/media/icn_merch_active.9268eed9.svg";